import type { TweetFeedResponseTweetsItem } from './tweetFeedResponseTweetsItem';

export interface TweetFeedResponse {
  currentPage?: number;
  hasNext?: boolean;
  totalElements?: number;
  totalPages?: number;
  tweets?: TweetFeedResponseTweetsItem[];
}
